import React, { useState, useRef, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
import {
  Button,
  Form,
  Input,
  Divider,
  ButtonGroup,
  Icon,
} from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";
import Dropzone from "../../../../components/Admin/Dropzone";

import {
  Container,
  Content,
  Title,
  Field,
  Label,
  StyledButton,
  StyledForm,
  StyledDropdown,
  ExcludeButtonContainer,
  CreatedInscritoContainer,
  LineContainer,
  StyledLabel,
  StyledLineContent,
  SemanticTable,
  SemanticButton,
  LinkRedirect,
} from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import InscritosEventosSelector from "../../../../components/Admin/InscritosEventosSelector";
import { useRouter } from "../../../../hooks/router";

const PerfilInscricoesEventos = (props) => {
  const [profile, setProfile] = useState(null);
  const [subscriptions, setSubscriptions] = useState(0);
  const [indications, setIndications] = useState([]);

  const [eventosOptions, setEventoOptions] = useState([
    { key: 1, text: "QP Summit 2021", value: 1 },
    {
      key: 2,
      text: "Lançamento do Pensamento Crítico",
      value: 3,
    },
  ]);

  const router = useRouter();

  const getProfile = useCallback(async (id_inscricao) => {
    try {
      const params = {
        id_inscricao,
        list: 1,
      };

      const data = (
        await api
          .get("inscricoes-eventos/subscriptions", { params })
          .catch(() => null)
      )?.data;

      const { profile, subscriptions, indications } = data;

      setProfile(profile);
      setSubscriptions(subscriptions);
      setIndications(indications);
    } catch (err) {
      console.error(err);

      swal("Erro", "Não foi possível encontrar inscrito", "error");
    }
  }, []);

  useEffect(() => {
    const { id_inscricao } = router.query;

    getProfile(id_inscricao);
  }, [getProfile, router]);

  const getEventos = async () => {
    const eventos = (await api.get("eventos")).data;

    const newEventosOptions = eventos.map((evento) => ({
      key: evento.id,
      value: evento.id,
      text: evento.titulo,
    }));

    setEventoOptions(newEventosOptions);
  };

  useEffect(() => {
    getEventos();
  }, []);

  if (!profile) {
    return null;
  }

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Perfil</Title>

          <StyledForm>
            <Form.Field
              control={Input}
              label="Nome"
              placeholder="Nome"
              value={profile.nome}
            />
            <Form.Field
              control={Input}
              label="Email"
              placeholder="Email"
              value={profile.email}
            />
            <Form.Field
              control={Input}
              label="Token"
              placeholder="Token"
              value={profile.id}
            />

            <Form.Field>
              <Label>Evento</Label>
              <StyledDropdown
                fluid
                selection
                options={eventosOptions}
                value={profile.id_evento}
              />
            </Form.Field>
          </StyledForm>

          <Title>Indicações</Title>

          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>Token</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Email</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Data de cadastro
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Indicações</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>

            <SemanticTable.Body>
              {indications.map((inscrito) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell> {inscrito.id} </SemanticTable.Cell>
                  <SemanticTable.Cell> {inscrito.nome} </SemanticTable.Cell>
                  <SemanticTable.Cell> {inscrito.email} </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {" "}
                    {inscrito.data_cadastro}{" "}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {" "}
                    {inscrito.indicacoes}{" "}
                  </SemanticTable.Cell>

                  <SemanticTable.Cell>
                    <LinkRedirect
                      to={`/admin/inscricoes-eventos/perfil/${inscrito.id}`}
                    >
                      <SemanticButton
                        title="Ver Perfil"
                        icon="edit icon"
                        info="edit"
                      />
                    </LinkRedirect>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))}
            </SemanticTable.Body>
          </SemanticTable>
        </Content>
      </Container>
    </div>
  );
};

export default withRouter(PerfilInscricoesEventos);
